<!--
    Summary:
        hkml.exhibition.web - pre-p
    ChangeLog:
        wangn on 2021/1/7 added
-->
<template>
    <p class="v-pre-p" title="pre-p">
        <i class="icon">-</i>
        <slot></slot>
    </p>
</template>

<script>
    export default {
        name: "pre-p"
    }
</script>

<style scoped lang="scss">
    .v-pre-p {
      position: relative;
      text-align: justify;
      padding-left: 2vw;
      .icon{
        position: absolute;
        left: 0;
        top: 0;
        width: 2vw;
        text-align: left;
      }
    }
</style>




// WEBPACK FOOTER //
// src/view/projects/y-dna-test/pre-p.vue